"use client";

import { useMemo } from "react";
import DocumentLayout from "../(components)/DocumentLayout";

const TomList = ({ params }: any) => {
  const navigationItems = useMemo(
    () => [
      { id: "einleitung", title: "Einleitung" },
      { id: "infrastruktur", title: "Infrastruktur / externes Server-Hosting" },
      {
        id: "sub-auftragsverarbeiter",
        title: "Weitere Sub-Auftragsverarbeiter",
      },
      { id: "allgemeine-tom", title: "Allgemeine TOM" },
    ],
    [],
  );

  return (
    <DocumentLayout
      params={params}
      titleKey="tom-list"
      navigationItems={navigationItems}
      basePath="/tom-list"
    >
      <div
        id="einleitung"
        className="flex flex-col items-start lg:flex-row gap-8"
      >
        <div className="w-full flex flex-col gap-6">
          <h2 className="font-bold text-[20px] leading-[160%] text-[#031F47]">
            Einleitung
          </h2>
          <p>
            OMTO GmbH (OMTO) hat die Sicherheit gem. Art. 28 Abs. 3 lit. c, 32
            DSGVO herzustellen. Bei den nachfolgend aufgeführten technischen und
            organisatorischen Maßnahmen (TOM) handelt es sich um Maßnahmen der
            Datensicherheit und zur Gewährleistung eines dem Risiko angemessenen
            Schutzniveaus hinsichtlich der Vertraulichkeit, der Integrität, der
            Verfügbarkeit sowie der Belastbarkeit der Systeme. Die TOM gelten
            für alle von OMTO angebotenen digitalen Dienste, die OMTO im Rahmen
            der Auftragsverarbeitung (Art. 28 DSGVO) ausführt.
          </p>
          <p>
            Die TOM beziehen sich auf die personenbezogenen Daten der Nutzer der
            digitalen Dienste (Nutzerdaten) sowie auf die personenbezogenen
            Daten, die für den Auftraggeber als Verantwortlichen oder
            Oberauftragsverarbeiter verarbeitet werden (Inhaltsdaten). Zu den
            Inhaltsdaten gehören insbesondere die Datenkategorien aus dem
            Formular „Verordnung einer Krankenbeförderung Muster 4“.
          </p>
          <p>
            Die TOM unterliegen dem technischen Fortschritt und der
            Weiterentwicklung. Insoweit ist es OMTO gestattet, alternative
            adäquate Maßnahmen zu implementieren. Das Sicherheitsniveau der
            bestehenden Maßnahmen wird dabei nicht unterschritten und
            wesentliche Änderungen werden dokumentiert.
          </p>
        </div>
      </div>

      <div
        id="infrastruktur"
        className="flex flex-col items-start lg:flex-row gap-8"
      >
        <div className="w-full flex flex-col gap-6">
          <h2 className="font-bold text-[20px] leading-[160%] text-[#031F47]">
            Infrastruktur / externes Server-Hosting
          </h2>
          <p>
            OMTO betreibt die digitalen Dienste ausschließlich auf der
            Infrastruktur des auf externes Server-Hosting spezialisierten
            Sub-Auftragsverarbeiters Amazon Web Services EMEA SARL (AWS) am
            Standort Frankfurt am Main. In den Räumlichkeiten von OMTO selbst
            werden keine Nutzerdaten oder Inhaltsdaten gespeichert oder
            verarbeitet. Die AWS-Datenzentren genügen höchsten Sicherheits- und
            Datenschutzanforderungen und wurden u.a. hinsichtlich folgender
            Normen geprüft:
          </p>
          <ul className="list-disc pl-7">
            <li>BSI C5-Testat</li>
            <li>
              SO/IEC 27001:2013 (ISO - International Organization for
              Standardization)
            </li>
            <li>SOC 1, SOC 2/SSAE 16/ISAE 3402 (SAS 70 Type II)</li>
            <li>PCI Level 1</li>
          </ul>
          <p>
            AWS ist so konzipiert, dass Kunden die Kontrolle über ihre Inhalte
            haben, einschließlich wo und wie sie gespeichert werden, sowie wer
            Zugriff darauf hat. Insbesondere mit den folgenden Optionen behält
            OMTO während des gesamten Lebenszyklus der Inhalte die Kontrolle
            z.B. über die Klassifizierung der Inhalte, Zugriffskontrolle,
            Aufbewahrung und Löschung der Daten:
          </p>
          <ul className="list-disc pl-7">
            <li>
              OMTO definiert, wo der Inhalt gespeichert werden soll,
              beispielsweise den Typ und geografischen Standort der Speicherung.
              OMTO hat Deutschland als geografischen Standort definiert, wo
              ausschließlich die Datenverarbeitung stattfindet.
            </li>
            <li>
              OMTO definiert das Inhaltsformat (z.B. Klartext, maskiert,
              anonymisiert oder verschlüsselt). OMTO definiert das Inhaltsformat
              in angemessener Berücksichtigung des Risikos für die jeweiligen
              Datenkategorien.
            </li>
            <li>
              OMTO verwendet weitere Zugriffssteuerungen, etwa Identitäts- und
              Zugriffsmanagement sowie Sicherheitsanmeldeinformationen.
            </li>
          </ul>
          <p>
            Der Serverstandort ist Frankfurt am Main. Aktuelle Angaben zum
            Sicherheitskonzept von AWS sind abrufbar unter:{" "}
            <a
              href="https://aws.amazon.com/de/about-aws/global-infrastructure/"
              target="_blank"
              rel="noreferrer"
              className="link-primary"
            >
              https://aws.amazon.com/de/about-aws/global-infrastructure/
            </a>
          </p>
          <p>
            Informationen zu den TOM für das externe Server-Hosting sind
            abrufbar unter:{" "}
            <a
              href="https://aws.amazon.com/de/compliance/data-center/controls/"
              target="_blank"
              rel="noreferrer"
              className="link-primary"
            >
              https://aws.amazon.com/de/compliance/data-center/controls/
            </a>
          </p>
        </div>
      </div>

      <div
        id="sub-auftragsverarbeiter"
        className="flex flex-col items-start lg:flex-row gap-8"
      >
        <div className="w-full flex flex-col gap-6">
          <h2 className="font-bold text-[20px] leading-[160%] text-[#031F47]">
            Weitere Sub-Auftragsverarbeiter
          </h2>
          <p>
            OMTO nutzt für einzelne Schritte innerhalb der digitalen Dienste
            (z.B. Form Validation) die Plattform Microsoft Azure. Die
            Cloudplattformen und -dienste von Microsoft genügen höchsten
            Sicherheits- und Datenschutzanforderungen und sind nach ISO/IEC
            27001:2013 Information Security Management Standards zertifiziert.
          </p>
          <p>
            Der Ort der Datenverarbeitung (Datenresidenz) ist Deutschland.
            Microsoft speichert oder verarbeitet Kundendaten außerhalb der vom
            Kunden angegebenen Geografie nicht ohne dessen Genehmigung. Aktuelle
            Angaben zur Datenresidenz in Azur sind abrufbar unter:{" "}
            <a
              href="https://azure.microsoft.com/de-de/explore/global-infrastructure/data-residency/#select-geography"
              target="_blank"
              rel="noreferrer"
              className="link-primary"
            >
              https://azure.microsoft.com/de-de/explore/global-infrastructure/data-residency/#select-geography
            </a>
          </p>
          <p>
            Informationen zu den TOM für die Dienste in Microsoft Azure sind
            abrufbar unter:{" "}
            <a
              href="https://learn.microsoft.com/de-de/compliance/regulatory/gdpr-arc-azure-dynamics"
              target="_blank"
              rel="noreferrer"
              className="link-primary"
            >
              https://learn.microsoft.com/de-de/compliance/regulatory/gdpr-arc-azure-dynamics
            </a>
          </p>
        </div>
      </div>

      <div
        id="allgemeine-tom"
        className="flex flex-col items-start lg:flex-row gap-8"
      >
        <div className="w-full flex flex-col gap-6">
          <h2 className="font-bold text-[20px] leading-[160%] text-[#031F47]">
            Allgemeine TOM
          </h2>
          <p>
            Da OMTO die Infrastruktur von AWS nutzt, beschränken sich die
            nachstehenden Informationen auf die von OMTO selbst implementierten
            allgemeinen TOM. Im Übrigen wird ausdrücklich auf die oben
            verlinkten Informationen zu den TOM von AWS und Microsoft Azure
            Bezug genommen.
          </p>

          <div className="mt-8">
            <h3 className="font-bold text-[18px] mb-4 text-[#031F47]">
              Pseudonymisierung und Verschlüsselung
            </h3>
            <ul className="list-disc pl-7 space-y-2">
              <li>
                Bei Übertragung von personenbezogenen Daten kommen
                Transportverschlüsselungen nach aktuellem Stand der Technik zum
                Einsatz.
              </li>
              <li>
                Datenübertragung vom Eingabegerät erfolgt per VPN-Tunneling über
                das MDM-System Samsung Knox verschlüsselt.
              </li>
              <li>
                Passwörter werden nach aktuellem Stand der Technik gehasht
                gespeichert.
              </li>
              <li>
                In AWS gespeicherte personenbezogene Daten sind sofern
                erforderlich und dem Risiko entsprechend nach aktuellem Stand
                der Technik verschlüsselt.
              </li>
              <li>Daten in Backups werden verschlüsselt.</li>
            </ul>
          </div>

          <div className="mt-8">
            <h3 className="font-bold text-[18px] mb-4 text-[#031F47]">
              Vertraulichkeit und Integrität
            </h3>

            <div className="mb-6">
              <h4 className="font-semibold mb-2">Zutrittskontrolle</h4>
              <p className="mb-2">
                Ein Zutritt zu den Rechenzentren, in denen Nutzer- und
                Inhaltsdaten gespeichert werden, ist nur dann möglich, wenn die
                Zutrittsrichtlinien des Anbieters einen solchen Zutritt
                vorsehen. Eine Datenverarbeitung außerhalb des Rechenzentrums
                erfolgt nicht, der Zugriff erfolgt über Client-Geräte. Um
                sicherzustellen, dass Unbefugten der Zutritt zu Client-Geräten,
                mit denen Daten abgerufen oder genutzt werden, verwehrt ist,
                trifft OMTO folgende Maßnahmen:
              </p>
              <ul className="list-disc pl-7 space-y-1">
                <li>Zutritts-Richtlinie</li>
                <li>Schlüsselregelung / Schlüsselliste</li>
                <li>Chipkarten-/Transponder-Schließsystem</li>
                <li>Sicherheitsschlösser</li>
                <li>Sicherheits- und Schließdienst</li>
                <li>Mitarbeiterausweise mit Lichtbild</li>
                <li>Sensibilisierung der Mitarbeiter zum sicheren Verhalten</li>
                <li>Protokollierung der Besucher</li>
              </ul>
            </div>

            <div className="mb-6">
              <h4 className="font-semibold mb-2">Zugangskontrolle</h4>
              <p className="mb-2">
                Zur Verhinderung des Eindringens in das
                Datenverarbeitungs-System seitens unbefugter Personen, sowie zur
                Sicherstellung, dass der Versuch eines unbefugten Zugangs nicht
                unbemerkt bleibt, trifft OMTO folgende Maßnahmen:
              </p>
              <ul className="list-disc pl-7 space-y-1">
                <li>Zuordnung von Benutzerrechten</li>
                <li>Zuordnung von Benutzerprofilen zu IT-Systemen</li>
                <li>
                  Authentifikation mit individualisiertem Benutzer/Passwort
                </li>
                <li>Einsatz von VPN-Technologie bzw. VPN-Tunneln</li>
                <li>Verschlüsselung von Datenträgern</li>
                <li>Einsatz von Anti-Viren-Software auf den Client-Geräten</li>
                <li>Einsatz einer Hardware-Firewall auf den Client-Geräten</li>
                <li>
                  Kennwortrichtlinie (Mindestlänge, Komplexität, anlassbezogener
                  Wechsel)
                </li>
                <li>Richtlinie zum sicheren Umgang mit Anmeldeinformationen</li>
                <li>
                  Richtlinie zum sicheren Verhalten und Datenschutz am
                  Arbeitsplatz
                </li>
                <li>
                  Elektronisch gesicherter Zugang
                  (Zwei-Faktor-Authentifizierung)
                </li>
                <li>
                  Sicherung von DV-Geräten und Datenspeichern durch
                  hardwareseitige Verschlüsselung
                </li>
                <li>
                  Protokollierung aller wesentlichen Administrationstätigkeiten
                  und Transaktionen
                </li>
              </ul>
            </div>

            <div className="mb-6">
              <h4 className="font-semibold mb-2">Zugriffskontrolle</h4>
              <p className="mb-2">
                Um sicherzustellen, dass die zur Benutzung der
                Datenverarbeitungsanlagen befugten Personen ausschließlich auf
                die ihrer Zugriffsberechtigung unterliegenden personen-
                bezogenen Daten zugreifen können und unbefugtes Lesen, Kopieren,
                Verändern verhindert wird sowie der Versuch des unbefugten
                Zugriffs nicht unbemerkt bleibt, trifft OMTO folgende Maßnahmen:
              </p>
              <ul className="list-disc pl-7 space-y-1">
                <li>
                  Berechtigungskonzept für Mitarbeiter mit dedizierten
                  Zugriffsebenen (Profile, Rollen, Transaktionen und Objekte)
                </li>
                <li>
                  Rechteverwaltung der durch Systemadministratoren, deren Anzahl
                  auf das Minimum reduziert ist
                </li>
                <li>
                  Protokollierung und Auswertung von Zugriffen auf Anwendungen,
                  insbesondere bei der Eingabe, Änderung und Löschung von Daten
                </li>
                <li>Verschlüsselung von Datenträgern in Client-Geräten</li>
                <li>
                  regelmäßige Überprüfung der vergebenen Zugriffsberechtigungen
                </li>
                <li>
                  Rechteentzug bzw. -änderung bei Mitarbeiteraustritt bzw.
                  Aufgabenwechsel
                </li>
              </ul>
            </div>

            <div className="mb-6">
              <h4 className="font-semibold mb-2">Weitergabekontrolle</h4>
              <p className="mb-2">
                Um sicherzustellen, dass personenbezogene Daten bei der
                elektronischen Übertragung oder während des Transportes oder
                ihrer Speicherung auf Datenträgern nicht unbefugt gelesen,
                kopiert, verändert oder entfernt werden können, und dass ein
                Transport von Datenträgern mit personenbezogenen Daten so
                durchgeführt wird, dass kein Material verloren gehen kann,
                trifft OMTO folgende Maßnahmen:
              </p>
              <ul className="list-disc pl-7 space-y-1">
                <li>
                  Logging und Audit-Protokolle für System- bzw.
                  Anwendungsereignisse zur Überwachung oder Untersuchung von
                  Auffälligkeiten
                </li>
                <li>
                  Untersagung der Speicherung, Weitergabe und Transports von
                  Daten auf unverschlüsselten oder auf firmenfremden mobilen
                  Datenträgern
                </li>
                <li>
                  Verwendung von Verschlüsselungsverfahren nach aktuellem Stand
                  der Technik bei Speicherung von personenbezogenen Daten in
                  Datenbanken von AWS
                </li>
                <li>
                  zertifizierte Löschung von Datenträgern vor Wiederverwendung
                  (durch Dienstleister nach NIST 800-88)
                </li>
                <li>
                  ordnungsgemäße Vernichtung von Datenträgern (DIN 66399 unter
                  Berücksichtigung der einschlägigen Schutzklassen und
                  Sicherheitsstufen)
                </li>
                <li>Protokollierung der Vernichtung</li>
                <li>Nutzung von verschlüsselten Übertragungswegen</li>
                <li>sorgfältige Auswahl von Transportpersonal</li>
              </ul>
            </div>

            <div className="mb-6">
              <h4 className="font-semibold mb-2">Eingabekontrolle</h4>
              <p className="mb-2">
                Um sicherzustellen, dass nachträglich überprüft und festgestellt
                werden kann, ob und von wem personenbezogene Daten in
                Datenverarbeitungssysteme eingegeben, verändert oder entfernt
                worden sind, trifft OMTO folgende Maßnahmen:
              </p>
              <ul className="list-disc pl-7 space-y-1">
                <li>
                  Protokollierung der Eingabe, Änderung und Löschung von Daten
                </li>
                <li>
                  Nachvollziehbarkeit von Eingabe, Änderung und Löschung von
                  Daten durch individuelle Benutzernamen
                </li>
                <li>
                  Datenlöschung ausschließlich mit entsprechender Berechtigung
                  möglich
                </li>
              </ul>
            </div>

            <div className="mb-6">
              <h4 className="font-semibold mb-2">Auftragskontrolle</h4>
              <p className="mb-2">
                Um sicherzustellen, dass personenbezogene Daten, die von etwaig
                eingesetzten Dienstleistern verarbeitet werden, nur entsprechend
                der Weisungen verarbeitet werden können, trifft OMTO folgende
                Maßnahmen:
              </p>
              <ul className="list-disc pl-7 space-y-1">
                <li>angemessene Vertragsgestaltung</li>
                <li>
                  Auftragsverarbeitungsverträge mit Subauftragnehmern, mit denen
                  die Anforderungen des Auftraggebers auch dem Subauftragnehmern
                  auferlegt und wirksame Kontrollrechte vereinbart werden
                </li>
                <li>sorgfältige Auswahl von Dienstleistern</li>
                <li>
                  Prüfung und Dokumentation der beim Dienstleister getroffenen
                  TOM
                </li>
                <li>
                  schriftliche Weisungserteilung an Dienstleister bei wichtigen
                  Weisungen
                </li>
              </ul>
            </div>

            <div className="mb-6">
              <h4 className="font-semibold mb-2">Trennungskontrolle</h4>
              <p className="mb-2">
                Um sicherzustellen, dass zu unterschiedlichen Zwecken erhobene
                personenbezogene Daten getrennt verarbeitet werden können,
                trifft OMTO folgende Maßnahmen:
              </p>
              <ul className="list-disc pl-7 space-y-1">
                <li>
                  Daten werden entsprechend ihres Verwendungszweckes ins System
                  abgelegt und dargestellt
                </li>
                <li>Trennung der Daten nach Kunden</li>
                <li>Funktionstrennung / Produktivumgebung / Testumgebung</li>
                <li>Differenzierung im Rahmen eines Berechtigungskonzepts</li>
              </ul>
            </div>
          </div>

          <div className="mt-8">
            <h3 className="font-bold text-[18px] mb-4 text-[#031F47]">
              Verfügbarkeit und Wiederherstellbarkeit
            </h3>
            <p className="mb-4">
              Grundsätzlich sorgt AWS für die Verfügbarkeit und
              Wiederherstellbarkeit der Daten. Informationen hierzu sind
              abrufbar unter:
              <a
                href="https://aws.amazon.com/de/architecture/security-identity-compliance/?cards-all.sort-by=item.additionalFields.sortDate&cards-all.sort-order=desc&awsf.content-type=*all&awsf.methodology=*all"
                target="_blank"
                rel="noreferrer"
                className="link-primary"
              >
                https://aws.amazon.com/de/architecture/security-identity-compliance/
              </a>
            </p>
            <p className="mb-4">
              Zur Sicherstellung der Verfügbarkeit von personenbezogenen Daten,
              dem Schutz gegen zufällige Zerstörung oder Verlust und
              Gewährleistung der Wiederherstellung der Systeme im Störungsfall
              achtet OMTO darauf, dass folgende Maßnahmen implementiert sind:
            </p>
            <ul className="list-disc pl-7 space-y-1">
              <li>
                Backup- & Recoverykonzept zur Gewährleistung einer raschen
                Wiederherstellbarkeit
              </li>
              <li>
                Aufbewahrung von Datensicherungen an einem sicheren,
                ausgelagerten Ort
              </li>
              <li>
                Regelmäßige Überprüfung auf Wirksamkeit des Backup- &
                Recoverykonzepts
              </li>
            </ul>
          </div>

          <div className="mt-8">
            <h3 className="font-bold text-[18px] mb-4 text-[#031F47]">
              Datenschutzfreundlichen Voreinstellung / Datenschutz durch
              Technikgestaltung
            </h3>
            <p>
              Zum Zweck datenschutzfreundlicher Voreinstellung (Privacy by
              Default) und durch Technikgestaltung (Privacy by Design) achtet
              OMTO bei Entwicklung der Dienste allgemein darauf, dass nur die
              personenbezogenen Daten erhoben werden, die zur Erfüllung des
              jeweiligen Zwecks auch tatsächlich erforderlich sind.
            </p>
          </div>

          <div className="mt-8">
            <h3 className="font-bold text-[18px] mb-4 text-[#031F47]">
              Verfahren regelmäßiger Überprüfung
            </h3>
            <p className="mb-4">
              OMTO hat einen externen Datenschutzbeauftragten bestellt, zu
              dessen Aufgaben die Entwicklung, Einrichtung und Überwachung eines
              Datenschutz-Managementsystems sowie die Kontrolle der
              Verarbeitungstätigkeiten und Datenschutzmaßnahmen gehört.
            </p>
            <p>
              Regelmäßig findet eine Risikoanalyse durch die IT-Verantwortlichen
              bei OMTO statt, um die aktuelle Bedrohungslage einzuschätzen und
              etwaige Maßnahmen zur Umsetzung abzuleiten.
            </p>
          </div>
        </div>
      </div>
    </DocumentLayout>
  );
};

export default TomList;
